/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Созданная шифрованная ссылка
 * @export
 * @interface CreatedCryptoLink
 */
export interface CreatedCryptoLink {
  /**
   * Полный URL шифрованной ссылки (публичный GET /api/v1/crypto-links/{token})
   * @type {string}
   * @memberof CreatedCryptoLink
   */
  url: string
  /**
   * Момент истечения срока действия ссылки (ISO 8601)
   * @type {Date}
   * @memberof CreatedCryptoLink
   */
  expiresAt: Date
}

/**
 * Check if a given object implements the CreatedCryptoLink interface.
 */
export function instanceOfCreatedCryptoLink(
  value: object
): value is CreatedCryptoLink {
  if (!('url' in value) || value['url'] === undefined) return false
  if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false
  return true
}

export function CreatedCryptoLinkFromJSON(json: any): CreatedCryptoLink {
  return CreatedCryptoLinkFromJSONTyped(json, false)
}

export function CreatedCryptoLinkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreatedCryptoLink {
  if (json == null) {
    return json
  }
  return {
    url: json['url'],
    expiresAt: new Date(json['expiresAt']),
  }
}

export function CreatedCryptoLinkToJSON(value?: CreatedCryptoLink | null): any {
  if (value == null) {
    return value
  }
  return {
    url: value['url'],
    expiresAt: value['expiresAt'].toISOString(),
  }
}
